import { useMutation, useQuery } from "@tanstack/react-query";
import withApiHost from "./useApiHost";
import { FOREIGN_LANGUAGE, LANGUAGE_TYPE, NATIVE_LANGUAGE } from "../components/Dictionary";
import { DictionaryResponseType } from "../components/ContextLayer/DataProvider/types";

export type FetchOperations = 'dictionary' | 'correct' | 'incorrect';

export function useInitialFetcher(apiHost: string, currentLanguage: LANGUAGE_TYPE, deviceID: string | null | undefined) {
    return useQuery({
        queryKey: ['/api/dictionary', currentLanguage],
        queryFn: async () => {
            const response = await fetch(`${apiHost}/dictionary?deviceId=${deviceID}&mode=${currentLanguage === 'native' ? NATIVE_LANGUAGE : FOREIGN_LANGUAGE}`);
            return response.json();
        },
        staleTime: 5 * 60 * 1000
    });
}

export type AddWordData = { word: string; description: string; tags: string[] };

export function useAddWordMutation() {
    const apiHost = withApiHost();

    return useMutation<DictionaryResponseType, unknown, AddWordData>({
        mutationFn: async (data: AddWordData) => {
            const response: Response = await fetch(`${apiHost}/add?word=${data.word}&description=${data.description}&tags=${data.tags}`);
            return response.json();
        }
    });
}

export type UpdateWordData = {
    wordId: string | undefined,
    correct: 0 | 1,
    deviceID: string | null | undefined,
    currentLanguage: LANGUAGE_TYPE,
    tags?: Array<string>
};

export function useWordUpdaterMutation() {
    const apiHost = withApiHost();

    return useMutation<DictionaryResponseType, unknown, UpdateWordData>({
        mutationFn: async (data: UpdateWordData) => {
            const response: Response = await fetch(`${apiHost}/update?wordId=${data.wordId}&correct=${data.correct}&deviceId=${data.deviceID}&mode=${data.currentLanguage === 'native' ? NATIVE_LANGUAGE : FOREIGN_LANGUAGE}`);
            return await response.json();
        }
    });
}

// export function useUpdateStatistics() {
//     const apiHost = withApiHost();
//     const fetch = useFetch('update');

//     return useQuery({
//         queryKey: [`${apiHost}/update`],
//         queryFn: fetch
//     });
// }